import { UserRoleType } from '@/api';

export const AccessControlAction = {
  VIEW_USER_MANAGEMENT_TAB: 'viewUserManagementTab',
  VIEW_MEDICAL_RECORDS_TAB: 'viewMedicalRecordsTab',
  ADD_EDIT_USERS: 'addEditUsers',
  VIEW_ENTIRE_CASE_LIST: 'viewEntireCaseList',
  VIEW_CASES_ASSIGNED_TO_SELF: 'viewCasesAssignedToSelf',
  CREATE_EDIT_CASE: 'createEditCase',
  UPLOAD_DELETE_RAW_MEDICAL_RECORDS: 'uploadDeleteRawMedicalRecords',
  EXPORT_RAW_MEDICAL_RECORDS: 'exportRawMedicalRecords',
  START_PAGINATION_AI_PROCESSING: 'startPaginationAIProcessing',
  VIEW_BUNDLES: 'viewBundles',
  EDIT_BUNDLES: 'editBundles',
  VIEW_TIMELINE_CHRONOLOGY: 'viewTimelineChronology',
  EDIT_TIMELINE_CHRONOLOGY: 'editTimelineChronology',
  EXPORT_BUNDLES_TIMELINES_CHRONOLOGIES: 'exportBundlesTimelinesChronologies',
  /**
   * Asking live Medical Match questions and triggering a re-run. On for every
   * role, so it follows whoever can see the Medical Match tab.
   */
  USE_LIVE_MEDICAL_MATCH: 'useLiveMedicalMatch',
  GLOBAL_ADMIN_ONLY: 'globalAdminOnly',
} as const;

export type AccessControlAction = (typeof AccessControlAction)[keyof typeof AccessControlAction];

export type AccessControlMatrix = Record<UserRoleType, Record<AccessControlAction, boolean>>;

export const ACCESS_CONTROL_MATRIX: AccessControlMatrix = {
  [UserRoleType.GLOBAL_ADMIN]: {
    viewUserManagementTab: true,
    viewMedicalRecordsTab: true,
    addEditUsers: true,
    viewEntireCaseList: true,
    viewCasesAssignedToSelf: true,
    createEditCase: true,
    uploadDeleteRawMedicalRecords: true,
    exportRawMedicalRecords: true,
    startPaginationAIProcessing: true,
    viewBundles: true,
    editBundles: true,
    viewTimelineChronology: true,
    editTimelineChronology: true,
    exportBundlesTimelinesChronologies: true,
    useLiveMedicalMatch: true,
    globalAdminOnly: true,
  },
  [UserRoleType.ADMIN]: {
    viewUserManagementTab: true,
    viewMedicalRecordsTab: true,
    addEditUsers: true,
    viewEntireCaseList: true,
    viewCasesAssignedToSelf: true,
    createEditCase: true,
    uploadDeleteRawMedicalRecords: true,
    exportRawMedicalRecords: true,
    startPaginationAIProcessing: true,
    viewBundles: true,
    editBundles: true,
    viewTimelineChronology: true,
    editTimelineChronology: true,
    exportBundlesTimelinesChronologies: true,
    useLiveMedicalMatch: true,
    globalAdminOnly: false,
  },
  [UserRoleType.MEDICAL_RECORDS_ADMIN]: {
    viewUserManagementTab: true,
    viewMedicalRecordsTab: true,
    addEditUsers: false,
    viewEntireCaseList: true,
    viewCasesAssignedToSelf: true,
    createEditCase: true,
    uploadDeleteRawMedicalRecords: true,
    exportRawMedicalRecords: true,
    startPaginationAIProcessing: true,
    viewBundles: true,
    editBundles: true,
    viewTimelineChronology: true,
    editTimelineChronology: true,
    exportBundlesTimelinesChronologies: true,
    useLiveMedicalMatch: true,
    globalAdminOnly: false,
  },
  [UserRoleType.MANAGER]: {
    viewUserManagementTab: true,
    viewMedicalRecordsTab: true,
    addEditUsers: false,
    viewEntireCaseList: true,
    viewCasesAssignedToSelf: true,
    createEditCase: true,
    uploadDeleteRawMedicalRecords: true,
    exportRawMedicalRecords: true,
    startPaginationAIProcessing: true,
    viewBundles: true,
    editBundles: true,
    viewTimelineChronology: true,
    editTimelineChronology: true,
    exportBundlesTimelinesChronologies: true,
    useLiveMedicalMatch: true,
    globalAdminOnly: false,
  },
  [UserRoleType.NURSE]: {
    viewUserManagementTab: false,
    viewMedicalRecordsTab: false,
    addEditUsers: false,
    viewEntireCaseList: false,
    viewCasesAssignedToSelf: true,
    createEditCase: false,
    uploadDeleteRawMedicalRecords: true,
    exportRawMedicalRecords: true,
    startPaginationAIProcessing: true,
    viewBundles: true,
    editBundles: true,
    viewTimelineChronology: true,
    editTimelineChronology: true,
    exportBundlesTimelinesChronologies: true,
    useLiveMedicalMatch: true,
    globalAdminOnly: false,
  },
  [UserRoleType.LAWYER]: {
    viewUserManagementTab: false,
    viewMedicalRecordsTab: false,
    addEditUsers: false,
    viewEntireCaseList: true,
    viewCasesAssignedToSelf: true,
    createEditCase: true,
    uploadDeleteRawMedicalRecords: true,
    exportRawMedicalRecords: true,
    startPaginationAIProcessing: true,
    viewBundles: true,
    editBundles: true,
    viewTimelineChronology: true,
    editTimelineChronology: true,
    exportBundlesTimelinesChronologies: true,
    useLiveMedicalMatch: true,
    globalAdminOnly: false,
  },
};
